import BaseModule from './BaseModule.js';

class OtcPaymentTransfer extends BaseModule {
  async paginate({ page, per_page, term, status, customer_id }) {
    return await this.get(`back-office/otc/transfer/payments`, {
      params: { page, per_page, term, status, customer_id },
    });
  }

  async fetch(id) {
    return await this.get(`back-office/otc/transfer/payments/${id}`);
  }
}

export default OtcPaymentTransfer;
